/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import ClearTelemetryPage from '@/pages/Telemetry/ClearTelemetryPage';

export function ClearTelemetryRoute() {
  return <ClearTelemetryPage />;
}
